import { motion } from "framer-motion";
import React from "react";
import { AppStoreButton } from "./AppStoreButton.tsx";

interface HeroSectionProps {
  heroBg?: string;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ heroBg }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      {heroBg && (
        <div className="absolute inset-0 z-0">
          <img
            src={heroBg}
            alt="Man facing mirror of self discovery"
            className="w-full h-full object-cover opacity-50 mix-blend-overlay"
          />
          {/* Softened gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/30 via-zinc-950/50 to-zinc-950" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_90%)]" />
        </div>
      )}

      <div className="relative z-10 container mx-auto px-6 flex flex-col items-start text-left max-w-5xl mt-10">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex items-center gap-3 mb-6"
        >
          <div className="h-px w-12 bg-primary" />
          <span className="text-primary font-bold tracking-widest uppercase text-xs">
            The Ultimate Social Simulator
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mb-4"
        >
          <h1 className="text-4xl md:text-6xl font-heading font-bold tracking-tight text-white mb-2">
            Flirt<span className="text-primary">Machine</span>
          </h1>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold tracking-tighter leading-[1.0] mb-8 max-w-4xl"
        >
          Play the Game. <br />
          <span className="text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.15)]">
            Master the Skill.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          className="text-lg md:text-2xl text-zinc-300 max-w-2xl mb-12 leading-relaxed font-light border-l-2 border-white/10 pl-6"
        >
          Chat with sophisticated AI personas. Get instant, honest feedback on your vibe. It's fun, challenging, and the
          fastest way to level up your social intelligence.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
          className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl"
        >
          <AppStoreButton variant="ios" />
          <AppStoreButton variant="android" />
        </motion.div>
      </div>
    </section>
  );
};
